export interface ButtonProps {
  className?: string;
  variant: ButtonVariant;
  size: ButtonSize;
  onClick: () => null;
  children?: React.ReactNode;
  to?: string;
}

export enum ButtonVariant {
  PRIMARY = "primary",
  ACCENT = "accent",
}

export enum ButtonSize {
  SMALL = "small",
  MEDIUM = "medium",
  LARGE = "large",
}